import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { DetailedFollowUpTicket } from 'src/types/followUp';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

const useTicketDetailQuery = (ticketId?: string | number | null) => {
  const endpoint = useMemo(
    () =>
      generatePath(apiPaths.FOLLOW_UP.TICKETS.DETAIL, {
        id: ticketId ?? 'placeholder-that-will-never-be-used',
      }),
    [ticketId],
  );

  return useQuery<DetailedFollowUpTicket>({
    queryKey: [endpoint],
    enabled: !!ticketId,
    queryFn: ({ signal }) =>
      HttpService.get(endpoint, {}, true, { signal })
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => Promise.reject(response.status)),
  });
};

export default useTicketDetailQuery;
